<template>
  <!-- pl-24 -->
  <div class="rounded py-8 pr-3 bg-grey-400 flex items-center">
    <div class="max-w-xs w-full flex-shrink-0 flex mx-3">
      <div
        class="
          flex
          rounded
          w-145
          h-145
          m-auto
          bg-white-900
          filter
          drop-shadow-md
        "
      >
        <img
          src="@/assets/publishers/1.png"
          alt="Publisher company name"
          class="h-auto m-auto"
          width="120"
        />
      </div>
    </div>

    <div class="max-w-screen-sm">
      <h1 class="text-black-900 text-3xl font-medium mb-4">Epigram Bookshop</h1>
      <div class="space-y-3">
        <p class="text-black-600 text-base">
          Epigram Books is an independent publisher that began as a division of
          the multiple award-winning communications design firm Epigram. In
          2011, it was registered as a separate entity to champion Singaporean
          literature.
        </p>
        <p class="text-black-600 text-base">
          Since then, Epigram Books has published all manner of fiction and
          non-fiction, from novels to picture books, memoirs to cookbooks,
          graphic novels to poetry.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardPublisherDetail",
};
</script>
